import { Environment, EnvironmentCode } from './environment.model';

export const environment: Environment = {
  production: true,
  env: EnvironmentCode.staging,
  dataProvider: 'api',
  apiRootUrl: 'https://sta-contacts.finstral.cloud/',
  apiReportUrl: 'https://staging-contacts-api.finstral.cloud/Report/LeadOverview',
  gtmUid: '',
  passwordChangeRoot: 'https://staging-login.finstral.cloud/Account/ChangePassword/',
  cloudUrl: 'https://sta.finstral.cloud',
  productFruitsWorkspace: 'gzdbZUqKhUsGbnIp',
  productFruitsChecklistId: 10900,
  cryptoSalt: 'finstral_public_salt',
};
